import {
  NoteAvancementBanqueEnum
} from "../client/backend-client/generated"

export const getAvancementBanqueLabel = (avancementBanque: NoteAvancementBanqueEnum) => {
  switch (avancementBanque) {
    case NoteAvancementBanqueEnum.PAS_DE_CONTACT_OU_DEBUT_DE_LA_DEMANDE_EN_COURS:
      return "Pas de contact ou début de la demande en cours"
    case NoteAvancementBanqueEnum.EN_ATTENTE_REPONSE_DE_LA_BANQUE:
      return "En attente de réponse de la banque"
    case NoteAvancementBanqueEnum.ACCORD_DE_PRINCIPE_ORAL:
      return "Accord de principe oral"
    case NoteAvancementBanqueEnum.ACCORD_ECRIT:
      return "Accord écrit"
    case NoteAvancementBanqueEnum.REFUS_DE_LA_BANQUE:
      return "Refus de la banque"
    case NoteAvancementBanqueEnum.NON_CONCERNE:
      return "Non concerné"
    default:
      return ""
  }
}